/** модальное окно для выбора локализаций в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { FloatModal } from "components/special";
import { AudioPreview } from "../../standart";

const { api } = adminAPI.actions;

const FloatVoicesModal = (props) => {
  return (
    <FloatModal
      header={<IntlMessages id="Sounds.Voices" />}
      {...props}
      head={(search, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="Sounds.Voices.name" />
            </th>
            <th>
              <IntlMessages id="Sounds.Voices.voice" />
            </th>
            <th>
              <IntlMessages id="Sounds.Voices.sampleFile" />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(value, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!value.enabled ? "text-strike" : ""}>
            {value.name}
          </td>
          <td onClick={clickHandler} className={!value.enabled ? "text-strike" : ""}>
            {value.voice}
          </td>
          <td>{value.fileId && <AudioPreview file={{ _id: value.fileId }} />}</td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatVoices = (props) => {
  return <FloatVoicesModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/sounds/voices"),
})(FloatVoices);
